export function pathIsDirectory(path: string): boolean {
    return path.endsWith('/');
}

export function pathIsFile(path: string): boolean {
    return !pathIsDirectory(path);
}

export function stripTrailingSlashFromPath(path: string): string {
    return path.replace(/\/+$/, '');
}

export function stripDoubleSlashesFromPath(path: string): string {
    return path.replace(/\/{2,}/g, '/');
}

export function addSlashToPath(path: string): string {
    return path.endsWith('/') ? path : path + '/';
}

export function getParentPath(path: string): string {
    return path.replace(/[a-z0-9_\-\.]+\/?$/, '');
}

export function getFilenameFromPath(path: string): string {
    return path.substr(path.lastIndexOf('/') + 1);
}

export function splitFilename(filename: string): [basename: string, extension: string] {
    const index = filename.lastIndexOf('.');
    if (index === -1) {
        return [filename, ''];
    }

    return [filename.slice(0, index), filename.slice(index + 1)];
}